import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorActions from '../../app/errors/errors-actions';
import { ENDPOINT_PATH_PARTICIPATION } from '../../../helpers/constants';
import selectedImprovementsActions from './selected-improvements-actions';

export const PARTICIPATION_STUDENT_RETRIEVED =
    'PARTICIPATION_STUDENT_RETRIEVED';

function getParticipationData(
    classroomId,
    studentProfileId,
    selectedDateFilter
) {
    return (dispatch) => {
        dispatch(selectedImprovementsActions.clearSelectedImprovements());
        Resources.studentReport
            .get({
                reportType: ENDPOINT_PATH_PARTICIPATION,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId,
                userProfileId: studentProfileId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    const participationData = payload.data;
                    dispatch({
                        type: PARTICIPATION_STUDENT_RETRIEVED,
                        payload: participationData
                    });
                    dispatch(
                        selectedImprovementsActions.setDefaultSelectedImprovements(
                            participationData.topicParticipations
                        )
                    );
                } else {
                    dispatch(
                        errorActions.addError(PARTICIPATION_STUDENT_RETRIEVED)
                    );
                }
            });
    };
}

export default {
    getParticipationData
};



// WEBPACK FOOTER //
// ./containers/participation/student/student-actions.js